module.exports = __webpack_public_path__ + "img/sForestSec_350x350.7e4cc3fe.jpg";